import React, { Component } from 'react';
import { connect } from 'react-redux';
import { safeGet, safeGetWithType } from 'iotera-base/json';
import { isNumber, isEmpty } from 'iotera-base/object';
import { setDeviceTag, setDeviceEmpty } from '../../../testActions';
import { store } from '../../../testStore';
import { withRouter } from 'react-router-dom';
import { domainIsTenant as dit, S } from '../../../routes/routes';

import { buildWBoundActions, buildWSelector } from '../../../redux/ducks';
import { actions as notificationActions } from '../../../redux/ducks/notification';
import { actions as modalActions } from '../../../redux/ducks/modal';

import { SubViewHeaderStep } from '../../../lib/components/subHeader';
import { Button } from '@material-ui/core';
import { bindActionCreators } from 'redux';
import { IoteraForm } from '../../../lib/components/form';
import { upperFirstLetter } from '../../../lib/components/formatter';
import { TextInputTag } from '../../../lib/components/textInputTag';
import {
  callWSingleRequestCall,
  addDeviceConfig,
  storeDeviceConfig,
  selectCategory,
  goToURLActivation,
} from '../function';
import Result from 'iotera-base/result';
import {
  setCallbackGlobal,
  unsetCallbackGlobal,
} from '../../../lib/components/callbackGlobal';

const INIT_TAGS = 'INIT_TAGS';
const DUMMY = 'DUMMY';
const MQTT = 'MQTT';
const RASPY = 'rasp-pi';
const ADD_DUMMY = 'ADD_DUMMY';
const ADD_MQTT = 'ADD_MQTT';
const WKEY = 'TAG_CAT_LIST';
const wBoundActions = buildWBoundActions(WKEY);
const wSelector = buildWSelector(WKEY);

function schema(properties) {
  return {
    title: 'Pilih penanda yang akan dipakai dalam perangkat',
    type: 'object',
    required: [],
    properties,
  };
}

function RemoveArrayFromArray(arrCore, arrToRemove) {
  for (let j = 0; j < arrToRemove.length; j++) {
    let index = arrCore.indexOf(arrToRemove[j]);
    if (index > -1) {
      arrCore.splice(index, 1);
    }
  }
  return arrCore;
}

class Example extends Component {
  constructor(props) {
    super(props);
    let storeValue = store.getState();
    let dataToShow = storeValue;
    if (isEmpty(dataToShow)) {
      this.goBack();
    } else {
      if ('device' in dataToShow) {
        if (isEmpty(dataToShow.device)) {
          this.goBack();
        } else {
          dataToShow = dataToShow.device;
        }
      } else {
        this.goBack();
      }
    }
    this.state = {
      value: [],
      formData: dataToShow,
      values: '',
      loading: false,
      prevPath: '',
      multiTags: [],
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleCustomChangeForm = this.handleCustomChangeForm.bind(this);
  }

  componentDidMount() {
    const _this = this;
    const _props = _this.props;
    const domainIsTenant = dit(_props);
    // callback global
    setCallbackGlobal(_props);
    _props.wInitRequestCall({
      wparam: { ...domainIsTenant, path: '/service/web/tag/category/get' },
      wcallback: {
        started: function (id) {
          // TODO Loading
        },
        finished: function (id, result) {
          // TODO Loading
          _this.setState({
            loading: false,
            tags: safeGetWithType(result, ['body', 'categories'], []),
          });
        },
      },
    });
    _props.wSetConfig({
      single_config: {
        [ADD_DUMMY]: {
          wparam: {
            ...domainIsTenant,
            method: 'POST',
            path: '/service/web/device/dum/node/add',
          },
          wcallback: {
            finished: function (id, result) {
              if (result.code === Result.HTTP.OK) {
                let action = setDeviceEmpty();
                store.dispatch(action);
                _props.history.push('..' + S + '_device_list_');
                _props.showSingleNotification({
                  message: 'Sukses',
                  level: 'success',
                });
              } else {
                _props.showSingleNotification({
                  message: 'Gagal',
                  level: 'error',
                });
              }
              _this.setState({
                loading: false,
              });
            },
          },
        },
        [ADD_MQTT]: {
          wparam: {
            ...domainIsTenant,
            method: 'POST',
            path: '/service/web/device/mqtt/node/add',
          },
          wcallback: {
            finished: function (id, result) {
              if (result.code === Result.HTTP.OK) {
                let action = setDeviceEmpty();
                store.dispatch(action);
                _props.history.push('..' + S + '_device_list_');
                _props.showSingleNotification({
                  message: 'Sukses',
                  level: 'success',
                });
              } else {
                _props.showSingleNotification({
                  message: 'Gagal',
                  level: 'error',
                });
              }
              _this.setState({
                loading: false,
              });
            },
          },
        },
      },
    });
  }

  componentWillUnmount() {
    // callback global
    unsetCallbackGlobal(this.props);
  }

  componentWillReceiveProps(nextProps) {
    const _this = this;
    const _props = _this.props;
    if (nextProps.location !== _props.location) {
      _this.setState({ prevPath: _props.location });
    }
  }

  handleSubmit(event) {
    const _this = this;
    const _props = _this.props;
    const _state = _this.state;
    const config = '{}';
    let dataToShow = event.formData;
    let items = _props.items;
    let itemsObject = {};
    for (let i = 0; i < items.length; i++) {
      Object.assign(itemsObject, {
        [items[i].id]: {
          prefix: items[i].prefix,
        },
      });
    }
    const { multiTags } = _state;
    let tagCats = [...safeGetWithType(_state, ['formData', 'tag_cat'], [])];
    tagCats = RemoveArrayFromArray(tagCats, multiTags);
    let finalDataObj = {};
    let prefix = '';
    let tagId = '';
    for (let j = 0; j < tagCats.length; j++) {
      tagId = tagCats[j];
      let dataPrefix = dataToShow[tagId];
      prefix = itemsObject[tagId].prefix;
      if (dataPrefix === true) {
        dataPrefix = 'true';
      } else if (dataPrefix === false) {
        dataPrefix = undefined;
      }
      if (dataPrefix === undefined) {
        continue;
      }
      Object.assign(finalDataObj, {
        [prefix]: [dataPrefix],
      });
    }
    for (let k = 0; k < multiTags.length; k++) {
      tagId = multiTags[k];
      let value = safeGetWithType(_state, [tagId], []);
      prefix = itemsObject[tagId].prefix;
      if (value.length <= 0) {
        continue;
      }
      Object.assign(finalDataObj, {
        [prefix]: value,
      });
    }
    let action = setDeviceTag(finalDataObj);
    store.dispatch(action);
    let type = dataToShow['type'];
    let storeValue = store.getState();
    let dataToSubmit = { ...storeValue.device };
    if (type === DUMMY) {
      callWSingleRequestCall({ ..._props }, ADD_DUMMY, dataToSubmit);
    } else if (type === MQTT) {
      callWSingleRequestCall({ ..._props }, ADD_MQTT, dataToSubmit);
    } else if (type === RASPY) {
      dataToSubmit = addDeviceConfig(dataToSubmit, config);
      storeDeviceConfig(dataToSubmit);
      return _props.history.push('.' + S + 'sensors');
    } else {
      let category = dataToSubmit['category'];
      let selectedCategory = selectCategory(category);
      return goToURLActivation({ ..._props }, selectedCategory); // function for history.push to one of page activation
    }
  }

  goTo(link) {
    this.props.history.push(link);
  }

  goBack() {
    this.props.history.push('.' + S + 'info');
  }

  handleChangeArr = (id, prefix, event) => {
    const _this = this;
    const _state = _this.state;
    let multiTags = safeGetWithType(_state, ['multiTags'], []);
    multiTags.push(id);
    let newMultiTags = [...new Set(multiTags)];
    _this.setState({ [id]: event, multiTags: newMultiTags });
  };

  handleValidateArr = tag => {
    const _props = this.props;
    let value = tag[0];
    let firstChar = parseInt(value.charAt(0), 10);
    if (isNumber(firstChar)) {
      _props.showSingleNotification({
        message: 'Penanda tidak boleh diawali oleh angka!',
        level: 'error',
      });
    } else if (value.length > 16) {
      _props.showSingleNotification({
        message: 'Penanda maksimal 16 karakter!',
        level: 'error',
      });
    } else {
      _props.showSingleNotification({
        message: 'Penanda tidak boleh mengandung huruf kapital!',
        level: 'error',
      });
    }
  };

  // To Get Change on Form
  handleCustomChangeForm = () => event => {
    this.setState({
      formData: event.formData,
    });
  };

  render() {
    const _this = this;
    const _props = _this.props;
    const _state = _this.state;
    let items = safeGet(_props, ['items'], []);
    let { formData: dataToShow } = _state;
    let tagNotImport = [];
    let propertiesSchema = {};
    let propertiesUiSchema = {};
    let multiArr = {};
    let prefix = '';
    if (items.length > 0) {
      for (let i = 0; i < items.length; i++) {
        let item = { ...items[i] };
        let itemId = item.id;
        let itemName = upperFirstLetter(item.name);
        let cat = item.category;
        prefix = item.prefix;
        let definitions = safeGet(item, 'definitions', []);
        if (cat === 1) {
          let definitionsValueArray = [];
          tagNotImport.push(itemId);
          if (definitions.length === 0) {
            continue;
          }
          for (let z = 0; z < definitions.length; z++) {
            let definitionsValue = {};
            let valueToSubmit = [definitions[z].name_lc];
            definitionsValue.type = 'string';
            definitionsValue.enum = valueToSubmit;
            definitionsValue.title = definitions[z].name;
            definitionsValueArray.push(definitionsValue);
          }
          Object.assign(propertiesSchema, {
            [itemId]: {
              title: itemName,
              type: 'string',
              anyOf: definitionsValueArray,
            },
          });
        } else if (cat === 2) {
          tagNotImport.push(itemId);
          Object.assign(propertiesSchema, {
            [itemId]: {
              title: itemName,
              type: 'string',
            },
          });
        } else if (cat === 3) {
          tagNotImport.push(itemId);
          Object.assign(propertiesSchema, {
            [itemId]: {
              title: itemName,
              type: 'boolean',
            },
          });
          Object.assign(propertiesUiSchema, {
            [itemId]: {},
          });
        } else if (cat === 4) {
          tagNotImport.push(itemId);
          Object.assign(multiArr, {
            [itemId]: item,
          });
        }
      }
    }
    for (let j = 0; j < tagNotImport.length; j++) {}
    dataToShow.tag_cat = tagNotImport;
    let inputArr = [];
    let pattern = new RegExp('^[a-z][a-z0-9_ ]{0,15}$'); // regex min 1 char, first letter not number, max length 15
    for (let key in multiArr) {
      prefix = multiArr[key].prefix;
      let name = multiArr[key].name;
      let tags = safeGet(_state, [key], []);
      let customPlaceholder = 'Tambah pilihan';
      if (tags.length > 2) {
        customPlaceholder = '(maksimum 3)';
      }
      inputArr.push(
        <TextInputTag
          id={key}
          value={tags}
          label={name}
          prefix={prefix}
          onChange={_this.handleChangeArr.bind(_this)}
          pattern={pattern}
          maxTags={3}
          onlyUnique={true}
          addKeys={[9, 13, 32]}
          placeholder={customPlaceholder}
          onValidationReject={_this.handleValidateArr.bind(_this)}
          preventSubmit={false}
          textTooltip={
            'Tiap penanda harus unik, tidak mengandung huruf besar, tidak diawali angka, maksimum 16 karakter.'
          }
        />,
      );
    }
    let type = safeGetWithType(dataToShow, ['type'], 'DUMMY');
    return (
      <div className="view">
        {type === DUMMY || type === MQTT ? (
          <SubViewHeaderStep
            title="Tambah Perangkat"
            subTitle="Permohonan tambah perangkat baru"
            steps={['Kategori', 'Penanda']}
            activeStep={1}
          />
        ) : type === RASPY ? (
          <SubViewHeaderStep
            title="Tambah Perangkat"
            subTitle="Permohonan tambah perangkat baru"
            steps={['Kategori', 'Penanda', 'Konfigurasi', 'Aktivasi']}
            activeStep={1}
          />
        ) : (
          <SubViewHeaderStep
            title="Tambah Perangkat"
            subTitle="Permohonan tambah perangkat baru"
            steps={['Kategori', 'Penanda', 'Aktivasi']}
            activeStep={1}
          />
        )}
        <div className="io-container mt-12">
          <IoteraForm
            schema={schema(propertiesSchema)}
            uiSchema={propertiesUiSchema}
            formData={dataToShow}
            onChange={_this.handleCustomChangeForm()}
            onSubmit={_this.handleSubmit}
            style={{ marginBottom: 0 }}
          >
            {inputArr}
            <div className="button-right" style={{ marginTop: 20 }}>
              <Button
                variant="outlined"
                size="large"
                style={{ minWidth: '0%' }}
                onClick={_props.history.goBack}
              >
                Kembali
              </Button>
              {type === DUMMY || type === MQTT ? (
                <Button
                  variant="contained"
                  size="large"
                  color="primary"
                  type="submit"
                  style={{ marginLeft: 10, minWidth: '0%' }}
                >
                  Simpan
                </Button>
              ) : (
                <Button
                  variant="contained"
                  size="large"
                  color="primary"
                  type="submit"
                  style={{ marginLeft: 10, minWidth: '0%' }}
                >
                  Berikutnya
                </Button>
              )}
            </div>
          </IoteraForm>
        </div>
      </div>
    );
  }
}

const mapStateToProps = function (state) {
  return {
    items: wSelector.getSoleInitMappedRPayload(state, 'categories'),
  };
};

const mapDispatchToProps = dispatch => ({
  ...wBoundActions(dispatch),
  ...bindActionCreators(notificationActions, dispatch),
  ...bindActionCreators(modalActions, dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(Example));
